import { gameState, config } from '@js/index';
import { enablePointerEvents } from '@utils/pointer-events-control';

var redfrog = null;
var greenfrog = null;

export default class GameScene extends Phaser.Scene {
  constructor() {
    super({
      key: "GameScene",
    });
  }

  preload() {}

  create() {
    enablePointerEvents();
    this.scene.launch("HintScene");

    gameState.cam = this.cameras.main;
    config.audio.bgAudio.setVolume(0.1);
    this.correctAudio = this.sound.add("correctaudio").setVolume(0.2);
    this.frogJumpAudio = this.sound.add("frogJumpAudio").setVolume(0.05);
    this.wAudio = this.sound.add("waudio").setVolume(0.2);
    config.audio.ripcAudio = this.sound.add("ripcAudio").setVolume(0.1);
    //asnwers for questions as per question numbers
    const answers = [1, 1, 2, 3, 4, 4, 1, 3, 3, 4, 2];
    const cam = this.cameras.main;
    this.questionwidth = 1000; //cam pan width for each question
    this.jumpactive = false;
    this.greenfrogshadow = false;
    // this has all background and animation files and audios
    this.gameanims();
    if (!this.jumpactive) {
      redfrog.play("idlefrog");
    }

    this.lpad1.on("pointerdown", () => {
      this.lpad1.disableInteractive();

      this.T2.setAlpha(0);
      this.arrow1.destroy();

      this.tweens.add({
        targets: this.T3,
        alpha: 0,
        duration: 400,
        delay: 2000,
        ease: "Linear",
        onStart: () => {
          const scene2 = this.scene.get("HintScene");
          scene2.changeText(3);

          if (!gameState.retry) {
            this.time.delayedCall(
              700,
              () => {
                this.load.multiatlas("glitter", "assets/anims/rewardAnims/glitterAnim.json", "assets/anims/rewardAnims/");
                this.load.start();
              },
              [],
              this
            );
          }
        },

        onComplete: () => {
          this.T3audio.play();

          this.time.delayedCall(
            this.T3audio.duration * 1000,
            () => {
              this.arrow2.setAlpha(1);
              this.tweens.add({
                targets: this.arrow2,
                y: {
                  getStart: () => 185,
                  getEnd: () => 190,
                },
                duration: 400,
                ease: "Linear",
                loop: -1,
                yoyo: true,
              });
              this.lil1.setInteractive();
            },
            [],
            this
          );
        },
      });

      redfrog.startFollow({
        positionOnPath: true,
        duration: 650,
        yoyo: false,
        repeat: 0,
        rotateToPath: false,
        verticalAdjust: false,
        delay: () => {
          if (this.displayq && this.gamestart == 0) {
            return 1000;
          } else {
            return 0;
          }
        },
        onStart: () => {
          this.jumpactive = true;
          redfrog.play("redfjumpfull");
          this.frogJumpAudio.play();
          this.gamestart = 0;
          this.shadow1.setAlpha(0.5);

          this.tweens.add({
            targets: this.shadow1,
            scale: 0.75,
            duration: 310,
            yoyo: true,
            ease: "Linear",
          });

          //panning th cam towards the question
          cam.pan(640 + 725 + gameState.qnum * this.questionwidth, 360, 1000, "Sine.easeOut");

          if (this.displayq) {
            //creating objects for next question

            this.tweens.add({
              targets: this.shadow1,
              y: 317 + 110,
              duration: 650,
              ease: "Linear",
            });

            this.Qrips.push(this.add.sprite(725 + 1088 + gameState.qnum * this.questionwidth, 347, "rippleContactAnim").setOrigin(0.27));
            this.lpads.push(this.add.image(725 + 1088 + gameState.qnum * this.questionwidth, 347, "ipad").setOrigin(0));

            this.ripples = [this.Qrips[gameState.qnum], this.Qrips[gameState.qnum + 1], this.rip1, this.rip2, this.rip3, this.rip4];

            this.redfrog1 = this.add
              .sprite(813 + 491 - 40 - 50 + gameState.qnum * 1000, 180 - 20, "frogSinkAnim")
              .setOrigin(513 / 1280, 138 / 720)
              .setAlpha(0);
            this.redfrog2 = this.add
              .sprite(813 + 654 - 40 - 50 + gameState.qnum * 1000, 280 - 20, "frogSinkAnim")
              .setOrigin(513 / 1280, 138 / 720)
              .setAlpha(0);
            this.redfrog3 = this.add
              .sprite(813 + 444 - 40 - 50 + gameState.qnum * 1000, 412 - 20, "frogSinkAnim")
              .setOrigin(513 / 1280, 138 / 720)
              .setAlpha(0);
            this.redfrog4 = this.add
              .sprite(813 + 613 - 40 - 50 + gameState.qnum * 1000, 513 - 20, "frogSinkAnim")
              .setOrigin(513 / 1280, 138 / 720)
              .setAlpha(0);
            this.rip = true;
            this.clickActive = true;
          }
        },
        onComplete: () => {
          //different animations for different jumps

          this.jumpactive = false;
          this.time.delayedCall(
            700,
            () => {
              if (!this.jumpactive) {
                redfrog.play("idlefrog");
              }
            },
            this
          );

          if (this.displayq) {
            this.tweens.add({
              targets: [this.bubble1, this.bubble2, this.bubble3, this.bubble4, this.opt1, this.opt2, this.opt3, this.opt4],
              scale: 1,
              duration: 500,
              ease: "Linear",
              onStart: () => {
                for (let i = 0; i < 4; i++) {
                  this.tweens.add({
                    targets: this.opts[i],
                    x: this.opts[i].x + 62,
                    y: this.opts[i].y - 14,
                    duration: 450,
                    ease: "Linear",
                  });
                }
              },
            });

            this.Qrips[gameState.qnum].setOrigin(0.27).play("ripc");
            config.audio.ripcAudio.play();
            this.displayq = false;

            //Define lillipad properties

            this.lil1.on("pointerdown", () => {
              this.overlay.setAlpha(0);
              this.arrow2.setAlpha(0);
              this.T3.setAlpha(0);

              this.shadow1.setDepth(1);
              this.enablepads(false);
              var pathL1 = new Phaser.Curves.Path(813 + 45 + gameState.qnum * 1000, 317).splineTo([
                813 + 209 - 53 + gameState.qnum * 1000,
                287 - 97,
                813 + 318 - 53 + gameState.qnum * 1000,
                224.5 - 97,
                813 + 434.5 - 53 + gameState.qnum * 1000,
                224.5 - 97,
                813 + 491 - 40 + gameState.qnum * 1000,
                180,
              ]);
              redfrog.setPath(pathL1);

              this.tweens.add({
                targets: this.shadow1,
                y: 180 + 110,
                duration: 650,
                ease: "Linear",
              });

              if (answers[gameState.questionNumber + 1] == 1) {
                const scene2 = this.scene.get("HintScene");
                scene2.clickCorrect();

                scene2.clickProgress();

                this.time.delayedCall(
                  650,
                  () => {
                    this.rip1.setOrigin(0.27).play("ripc");
                    config.audio.ripcAudio.play();

                    this.bubble1.setTexture("bubble_c");
                    this.correctAudio.play();
                    this.opt1.setTexture(gameState.questionNumber + 1 + "_0_c");
                    this.tweens.add({
                      targets: [this.bubble2, this.bubble3, this.bubble4, this.opt2, this.opt3, this.opt4],
                      alpha: 0,
                      duration: 25,
                      ease: "Linear",
                      onStart: () => {
                        //this.bub1.setAlpha(1).play('burst')
                        this.bub2.setAlpha(1).play("burst");
                        this.bub3.setAlpha(1).play("burst");
                        this.bub4.setAlpha(1).play("burst");
                      },
                    });

                    this.NextQ(1);
                  },
                  [],
                  this
                );
              } else {
                const scene2 = this.scene.get("HintScene");
                scene2.clickWrong();

                this.lil1.play("sinkpad");
                this.time.delayedCall(
                  750,
                  () => {
                    this.bubble1.setTexture("bubble_w");
                    this.wAudio.play();
                    this.shadow1.setAlpha(0);

                    this.opt1.setTexture(gameState.questionNumber + 1 + "_0_w");

                    this.redfrog1.setAlpha(1);
                    redfrog.setAlpha(0);
                    this.redfrog1.play("sinkfrog");
                  },
                  [],
                  this
                );

                this.time.delayedCall(
                  4500,
                  () => {
                    if (gameState.attempts < 2) {
                      this.reattempt();
                    } else {
                      this.replaceq();
                    }
                  },

                  [],
                  this
                );
              }
            });

            this.lil2.on("pointerdown", () => {
              this.enablepads(false);

              var pathL2 = new Phaser.Curves.Path(813 + 45 + gameState.qnum * 1000, 317).splineTo([
                813 + 220 - 53 + gameState.qnum * 1000,
                334 - 97,
                813 + 326 - 53 + gameState.qnum * 1000,
                280 - 97,
                813 + 434.5 - 53 + gameState.qnum * 1000,
                262 - 97,
                813 + 586 - 53 + gameState.qnum * 1000,
                292 - 97,
                813 + 654 - 40 + gameState.qnum * 1000,
                280,
              ]);
              redfrog.setPath(pathL2);

              this.tweens.add({
                targets: this.shadow1,
                y: 280 + 110,
                duration: 650,
                ease: "Linear",
              });

              if (answers[gameState.questionNumber + 1] == 2) {
                const scene2 = this.scene.get("HintScene");
                scene2.clickCorrect();

                scene2.clickProgress();

                this.time.delayedCall(
                  650,
                  () => {
                    this.rip2.setOrigin(0.27).play("ripc");
                    config.audio.ripcAudio.play();
                    this.bubble2.setTexture("bubble_c");
                    this.correctAudio.play();

                    this.opt2.setTexture(gameState.questionNumber + 1 + "_1_c");

                    this.tweens.add({
                      targets: [this.bubble1, this.bubble3, this.bubble4, this.opt1, this.opt3, this.opt4],
                      alpha: 0,
                      duration: 25,
                      ease: "Linear",
                      onStart: () => {
                        this.bub1.setAlpha(1).play("burst");
                        //this.bub2.setAlpha(1).play('burst')
                        this.bub3.setAlpha(1).play("burst");
                        this.bub4.setAlpha(1).play("burst");
                      },
                    });

                    this.NextQ(2);
                  },
                  [],
                  this
                );
              } else {
                const scene2 = this.scene.get("HintScene");
                scene2.clickWrong();

                this.lil2.play("sinkpad");
                this.time.delayedCall(
                  650,
                  () => {
                    this.bubble2.setTexture("bubble_w");
                    this.wAudio.play();
                    this.shadow1.setAlpha(0);
                    this.opt2.setTexture(gameState.questionNumber + 1 + "_1_w");

                    this.redfrog2.setAlpha(1);
                    redfrog.setAlpha(0);
                    this.redfrog2.play("sinkfrog");
                  },
                  [],
                  this
                );

                this.time.delayedCall(
                  4500,
                  () => {
                    if (gameState.attempts < 2) {
                      this.reattempt();
                    } else {
                      this.replaceq();
                    }
                  },

                  [],
                  this
                );
              }
            });

            this.lil3.on("pointerdown", () => {
              this.enablepads(false);

              var pathL3 = new Phaser.Curves.Path(813 + 45 + gameState.qnum * 1000, 317).splineTo([813 + 230 - 53 + gameState.qnum * 1000, 356 - 97, 813 + 310 - 53 + gameState.qnum * 1000, 343 - 97, 813 + 425 - 53 + gameState.qnum * 1000, 395 - 97, 813 + 444 - 40 + gameState.qnum * 1000, 412]);
              redfrog.setPath(pathL3);

              this.tweens.add({
                targets: this.shadow1,
                y: 412 + 110,
                duration: 650,
                ease: "Linear",
              });

              if (answers[gameState.questionNumber + 1] == 3) {
                const scene2 = this.scene.get("HintScene");
                scene2.clickCorrect();

                scene2.clickProgress();

                this.time.delayedCall(
                  650,
                  () => {
                    this.rip3.setOrigin(0.27).play("ripc");
                    config.audio.ripcAudio.play();
                    this.bubble3.setTexture("bubble_c");
                    this.correctAudio.play();

                    this.opt3.setTexture(gameState.questionNumber + 1 + "_2_c");
                    this.tweens.add({
                      targets: [this.bubble2, this.bubble1, this.bubble4, this.opt2, this.opt1, this.opt4],
                      alpha: 0,
                      duration: 25,
                      ease: "Linear",
                      onStart: () => {
                        this.bub1.setAlpha(1).play("burst");
                        this.bub2.setAlpha(1).play("burst");
                        //this.bub3.setAlpha(1).play('burst')
                        this.bub4.setAlpha(1).play("burst");
                      },
                    });

                    this.NextQ(3);
                  },
                  [],
                  this
                );
              } else {
                const scene2 = this.scene.get("HintScene");
                scene2.clickWrong();

                this.lil3.play("sinkpad");
                this.time.delayedCall(
                  650,
                  () => {
                    this.bubble3.setTexture("bubble_w");
                    this.wAudio.play();
                    this.shadow1.setAlpha(0);
                    this.opt3.setTexture(gameState.questionNumber + 1 + "_2_w");

                    this.redfrog3.setAlpha(1);
                    redfrog.setAlpha(0);
                    this.redfrog3.play("sinkfrog");
                  },
                  [],
                  this
                );

                this.time.delayedCall(
                  4500,
                  () => {
                    if (gameState.attempts < 2) {
                      this.reattempt();
                    } else {
                      this.replaceq();
                    }
                  },

                  [],
                  this
                );
              }
            });

            this.lil4.on("pointerdown", () => {
              this.enablepads(false);

              if (answers[gameState.questionNumber + 1] == 4) {
                const scene2 = this.scene.get("HintScene");
                scene2.clickCorrect();

                scene2.clickProgress();

                this.time.delayedCall(
                  650,
                  () => {
                    this.rip4.setOrigin(0.27).play("ripc");
                    config.audio.ripcAudio.play();
                    this.bubble4.setTexture("bubble_c");
                    this.correctAudio.play();

                    this.opt4.setTexture(gameState.questionNumber + 1 + "_3_c");
                    this.tweens.add({
                      targets: [this.bubble2, this.bubble3, this.bubble1, this.opt2, this.opt3, this.opt1],
                      alpha: 0,
                      duration: 25,
                      ease: "Linear",
                      onStart: () => {
                        this.bub1.setAlpha(1).play("burst");
                        this.bub2.setAlpha(1).play("burst");
                        this.bub3.setAlpha(1).play("burst");
                        //this.bub4.setAlpha(1).play('burst')
                      },
                    });

                    this.NextQ(4);
                  },
                  [],
                  this
                );
              } else {
                const scene2 = this.scene.get("HintScene");
                scene2.clickWrong();

                this.lil4.play("sinkpad");
                this.time.delayedCall(
                  650,
                  () => {
                    this.bubble4.setTexture("bubble_w");
                    this.wAudio.play();
                    this.shadow1.setAlpha(0);
                    this.opt4.setTexture(gameState.questionNumber + 1 + "_3_w");

                    this.redfrog4.setAlpha(1);
                    redfrog.setAlpha(0);
                    this.redfrog4.play("sinkfrog");
                  },
                  [],
                  this
                );

                this.time.delayedCall(
                  4500,
                  () => {
                    if (gameState.attempts < 2) {
                      this.reattempt();
                    } else {
                      this.replaceq();
                    }
                  },

                  [],
                  this
                );
              }
              var pathL4 = new Phaser.Curves.Path(813 + 45 + gameState.qnum * 1000, 317).splineTo([813 + 227.5 - 53 + gameState.qnum * 1000, 380 - 97, 813 + 425 - 53 + gameState.qnum * 1000, 372 - 97, 813 + 534 - 53 + gameState.qnum * 1000, 424.5 - 97, 813 + 613 - 40 + gameState.qnum * 1000, 513]);
              redfrog.setPath(pathL4);

              this.tweens.add({
                targets: this.shadow1,
                y: 513 + 110,
                duration: 650,
                ease: "Linear",
              });
            });
          }

          if (this.repeatq) {
            this.repeatq = false;
            this.Qrips[gameState.qnum].setOrigin(0.27).play("ripc");
            config.audio.ripcAudio.play();
          }

          if (this.newq) {
            this.Qrips[gameState.qnum].setOrigin(0.27).play("ripc");
            config.audio.ripcAudio.play();
            this.newq = false;
            this.tweens.add({
              targets: [this.bubble1, this.bubble2, this.bubble3, this.bubble4, this.opt1, this.opt2, this.opt3, this.opt4],
              scale: 1,
              duration: 500,
              ease: "Linear",
              onStart: () => {
                for (let i = 0; i < 4; i++) {
                  this.tweens.add({
                    targets: this.opts[i],
                    x: this.opts[i].x + 62,
                    y: this.opts[i].y - 14,
                    duration: 450,
                    ease: "Linear",
                  });
                }
              },
            });
          }
        },
      });
    });
  }

  enablepads(val) {
    if (val) {
      this.clickActive = true;
      this.rip = true;
      this.lil1.setInteractive();
      this.lil2.setInteractive();
      this.lil3.setInteractive();
      this.lil4.setInteractive();
    } else {
      this.clickActive = false;
      this.lil1.disableInteractive();
      this.lil2.disableInteractive();
      this.lil3.disableInteractive();
      this.lil4.disableInteractive();
    }
  }

  startFlowers() {
    var f1 = this.add.image(385, 205, "flower").setOrigin(0);
    var f2 = this.add.image(460, 181, "flower").setOrigin(0);

    this.tweens.add({
      targets: f1,
      ease: "Circular.InOut",
      duration: 2000,
      delay: 200,
      repeatDelay: 500,
      x: {
        getStart: () => 385,
        getEnd: () => 385 - 10,
      },
      y: {
        getStart: () => 205,
        getEnd: () => 200,
      },
      yoyo: true,
      loop: -1,
    });

    this.tweens.add({
      targets: f2,
      ease: "Circular.InOut",
      duration: 2000,
      repeatDelay: 500,
      x: {
        getStart: () => 460,
        getEnd: () => 460 + 10,
      },
      y: {
        getStart: () => 181,
        getEnd: () => 185,
      },
      yoyo: true,
      loop: -1,
    });
  }
  gameanims() {
    this.T1audio = this.sound.add("T1audio").setVolume(0.2);
    this.T2audio = this.sound.add("T2audio").setVolume(0.2);
    this.T3audio = this.sound.add("T3audio").setVolume(0.2);

    var gbg = this.add.image(0, 0, "gbg").setOrigin(0);
    var gbg1 = this.add.image(5119 - 2.5, 0, "gbg").setOrigin(0);
    this.gbg2 = this.add.image(2 * (5119 - 2.5), 0, "gbg").setOrigin(0);

    var postFxPlugin = this.plugins.get("rexwarppipelineplugin");

    var postFxPipeline = postFxPlugin.add(gbg, {
      speedY: 1,
      frequencyX: 20,
      frequencyY: 20,
      amplitudeX: 2.5,
      amplitudeY: 2.5,
      speedX: 3,
    });

    var postFxPipeline1 = postFxPlugin.add(gbg1, {
      speedY: 1,
      frequencyX: 20,
      frequencyY: 20,
      amplitudeX: 2.5,
      amplitudeY: 2.5,
      speedX: 3,
    });

    //this.startFlowers()

    for (let i = 0; i < 6; i++) {
      var f1 = this.add.image(725 + 300 + i * this.questionwidth, 590, "flower").setOrigin(0);
      var f2 = this.add.image(725 + 1145 + i * this.questionwidth, 156, "flower").setOrigin(0);

      this.tweens.add({
        targets: f1,
        ease: "Circular.InOut",
        duration: 2000,
        delay: 200,
        repeatDelay: 500,
        x: {
          getStart: () => 725 + 300 + i * this.questionwidth,
          getEnd: () => 725 + 300 + i * this.questionwidth - 10,
        },
        y: {
          getStart: () => 590,
          getEnd: () => 585,
        },
        yoyo: true,
        loop: -1,
      });

      this.tweens.add({
        targets: f2,
        ease: "Circular.InOut",
        duration: 2000,
        repeatDelay: 500,
        x: {
          getStart: () => 725 + 1145 + i * this.questionwidth,
          getEnd: () => 725 + 1145 + i * this.questionwidth + 10,
        },
        y: {
          getStart: () => 156,
          getEnd: () => 160,
        },
        yoyo: true,
        loop: -1,
      });
    }
    this.add.image(0, 0, "leftBank").setOrigin(0);

    this.rip1 = this.add.sprite(725 + 491, 223, "rippleContactAnim").setOrigin(0.27);
    this.rip2 = this.add.sprite(725 + 654, 323, "rippleContactAnim").setOrigin(0.27);
    this.rip3 = this.add.sprite(725 + 444, 455, "rippleContactAnim").setOrigin(0.27);
    this.rip4 = this.add.sprite(725 + 613, 556, "rippleContactAnim").setOrigin(0.27);

    this.shadow1 = this.add
      .image(93 - 30 + 50, 317 + 110, "shadow")
      .setOrigin(0.5)
      .setTint(0x000)
      .setAlpha(0.5)
      .setDepth(1);

    this.overlay = this.add.sprite(0, 0, "gbg").setOrigin(0).setTint(0x000).setAlpha(0.5);

    this.rightbank = this.add.image(725 + 6000 + 1280, 0, "rightBank").setOrigin(1, 0);

    var r5 = this.add.rectangle(0, 0, 1280, 720, 0xffffff).setOrigin(0).setDepth(15).setAlpha(1);

    this.tweens.add({
      targets: r5,
      alpha: 0,
      duration: 500,
      ease: "Sine.easeInOut",
      onComplete: () => {
        this.T1audio.play();
        if (!gameState.retry) {
          this.load.multiatlas("spotlight", "assets/EndSceneAssets/spotlight/spotlightAnimNew.json", "assets/EndSceneAssets/spotlight");
          this.load.start();
        }
      },
    });

    this.anims.create({
      key: "redfjumpfull",
      frames: this.anims.generateFrameNames("redFrogJumpAnim", {
        start: 4,
        end: 31,
        zeroPad: 0,
        prefix: "redFrogJump",
        suffix: ".png",
      }),
      frameRate: 24,
      repeat: 0,
    });

    this.anims.create({
      key: "greenfjumpfull",
      frames: this.anims.generateFrameNames("greenFrogJumpAnim", {
        start: 4,
        end: 31,
        zeroPad: 0,
        prefix: "greenFrogJump",
        suffix: ".png",
      }),
      frameRate: 24,
      repeat: 0,
    });

    this.anims.create({
      key: "rrip",
      frames: this.anims.generateFrameNames("randomRippleAnim", {
        start: 0,
        end: 24,
        zeroPad: 0,
        prefix: "randomRipple",
        suffix: ".png",
      }),
      frameRate: 24,
      repeat: 0,
    });

    this.anims.create({
      key: "sinkpad",
      frames: this.anims.generateFrameNames("lillyPadSinkAnim", {
        start: 0,
        end: 113,
        zeroPad: 0,
        prefix: "lillyPadSink",
        suffix: ".png",
      }),
      frameRate: 24,
      repeat: 0,
    });

    this.anims.create({
      key: "burst",
      frames: this.anims.generateFrameNames("bubbleBurstAnim", {
        start: 22,
        end: 30,
        zeroPad: 0,
        prefix: "bubbleBurst",
        suffix: ".png",
      }),
      frameRate: 24,
      repeat: 0,
    });

    this.anims.create({
      key: "ripc",
      frames: this.anims.generateFrameNames("rippleContactAnim", {
        start: 0,
        end: 48,
        zeroPad: 0,
        prefix: "rippleContact",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: "idlefrog",
      frames: this.anims.generateFrameNames("frogBlink", {
        start: 39,
        end: 46,
        zeroPad: 0,
        prefix: "red_",
        suffix: ".png",
      }),
      frameRate: 24,
      repeat: -1,
      //delay:,
      repeatDelay: 3000,
    });

    this.anims.create({
      key: "sinkfrog",
      frames: this.anims.generateFrameNames("frogSinkAnim", {
        start: 19,
        end: 113,
        zeroPad: 0,
        prefix: "frogSink",
        suffix: ".png",
      }),
      frameRate: 24,
      repeat: 0,
    });

    this.lpad1 = this.add.image(813, 347, "ipad").setOrigin(0).setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.Qrip1 = this.add.sprite(813, 347, "rippleContactAnim").setOrigin(0.27);

    this.lpads = [this.lpad1];
    this.Qrips = [this.Qrip1];

    this.newq = false; // variable defined for controlling replace question function
    this.repeatq = false; // variable defined for controlling reattempt of question function

    var path1 = new Phaser.Curves.Path(131 - 38, 438 - 121).splineTo([257 - 38, 327.5 - 121, 459 - 38, 261.5 - 121, 640 - 38, 280 - 121, 813 + 45, 317]); //path for first jump into the lake

    redfrog = this.add
      .follower(path1, 93, 317, "redFrogJumpAnim")
      .setOrigin((89 * 1.5) / 1280, 336 / 720)
      .setDepth(2);

    //game objects for tutorial scene

    this.lil1 = this.add
      .sprite(725 + 491, 223, "lillyPadSinkAnim")
      .setOrigin(490 / 1280, 189 / 720)
      .setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.lil2 = this.add
      .sprite(725 + 654, 323, "lillyPadSinkAnim")
      .setOrigin(490 / 1280, 189 / 720)
      .setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.lil3 = this.add
      .sprite(725 + 444, 455, "lillyPadSinkAnim")
      .setOrigin(490 / 1280, 189 / 720)
      .setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.lil4 = this.add
      .sprite(725 + 613, 556, "lillyPadSinkAnim")
      .setOrigin(490 / 1280, 189 / 720)
      .setInteractive({ cursor: "pointer", pixelPerfect: true });

    this.bubble1 = this.add
      .image(725 + 634, 287, "bubble")
      .setOrigin(0, 0.78)
      .setScale(0)
      .setDepth(1);
    this.bubble2 = this.add
      .image(725 + 797, 387, "bubble")
      .setOrigin(0, 0.78)
      .setScale(0)
      .setDepth(1);
    this.bubble3 = this.add
      .image(725 + 587, 519, "bubble")
      .setOrigin(0, 0.78)
      .setScale(0)
      .setDepth(1);
    this.bubble4 = this.add
      .image(725 + 756, 619, "bubble")
      .setOrigin(0, 0.78)
      .setScale(0)
      .setDepth(1);

    this.opt1 = this.add
      .image(725 + 634, 287, gameState.questionNumber + 1 + "_0")
      .setOrigin(0.5, 1)
      .setScale(0)
      .setDepth(1);
    this.opt2 = this.add
      .image(725 + 797, 387, gameState.questionNumber + 1 + "_1")
      .setOrigin(0.5, 1)
      .setScale(0)
      .setDepth(1);
    this.opt3 = this.add
      .image(725 + 587, 519, gameState.questionNumber + 1 + "_2")
      .setOrigin(0.5, 1)
      .setScale(0)
      .setDepth(1);
    this.opt4 = this.add
      .image(725 + 756, 619, gameState.questionNumber + 1 + "_3")
      .setOrigin(0.5, 1)
      .setScale(0)
      .setDepth(1);

    this.bub1 = this.add
      .sprite(725 + 634 + 62, 287 - 50, "bubbleBurstAnim")
      .setDepth(1)
      .setAlpha(0);
    this.bub2 = this.add
      .sprite(725 + 797 + 62, 387 - 50, "bubbleBurstAnim")
      .setDepth(1)
      .setAlpha(0);
    this.bub3 = this.add
      .sprite(725 + 587 + 62, 519 - 50, "bubbleBurstAnim")
      .setDepth(1)
      .setAlpha(0);
    this.bub4 = this.add
      .sprite(725 + 756 + 62, 619 - 50, "bubbleBurstAnim")
      .setDepth(1)
      .setAlpha(0);

    this.opts = [this.opt1, this.opt2, this.opt3, this.opt4];

    this.postions = [634, 287, 797, 387, 587, 519, 756, 619];

    this.gamestart = 1;

    this.displayq = true; //variable to execute different animations for different jumps.

    this.T1 = this.add.image(378, 536, "T1").setAlpha(0);
    this.T2 = this.add.image(312, 254, "T2").setOrigin(0).setAlpha(0);
    this.T3 = this.add
      .image(725 + 803, 186, "T3")
      .setOrigin(0)
      .setAlpha(0);

    if (!gameState.retry) {
      this.time.delayedCall(
        1000,
        () => {
          this.load.multiatlas("baseCircle", "assets/anims/rewardAnims/baseCircleAnim.json", "assets/anims/rewardAnims/");
          this.load.start();
        },
        [],
        this
      );
    }
    this.arrow1 = this.add.image(800, 320, "arrow1").setOrigin(0).setAlpha(0);

    this.arrow2 = this.add
      .image(725 + 740, 190, "arrow2")
      .setOrigin(0)
      .setAlpha(0);
    this.lpad1.disableInteractive();
    this.lil1.disableInteractive();
    this.lil2.disableInteractive();
    this.lil3.disableInteractive();
    this.lil4.disableInteractive();

    this.tweens.add({
      targets: this.T2,
      alpha: 0,
      duration: 400,
      delay: 4000,
      ease: "Linear",
      onStart: () => {
        if (!gameState.retry) {
          this.time.delayedCall(
            500,
            () => {
              this.load.multiatlas("rewardLight", "assets/anims/rewardAnims/rewardLightAnim.json", "assets/anims/rewardAnims/");
              this.load.start();
            },
            [],
            this
          );
        }
        this.T1.setAlpha(0);

        const scene2 = this.scene.get("HintScene");
        scene2.changeText();
      },

      onComplete: () => {
        this.T2audio.play();

        this.time.delayedCall(
          this.T2audio.duration * 1000,
          () => {
            this.lpad1.setInteractive();
            this.arrow1.setAlpha(1);
            this.tweens.add({
              targets: this.arrow1,
              y: {
                getStart: () => 320,
                getEnd: () => 325,
              },
              duration: 400,
              ease: "Linear",
              loop: -1,
              yoyo: true,
            });
          },
          [],
          this
        );
        //console.log(this.T2audio.duration)
      },
    });
  }

  NextQ(padval) {
    gameState.qnum++;
    gameState.questionNumber++;
    gameState.correct++;
    gameState.attempts = 0;

    if (gameState.questionNumber >= 10) {
      this.time.delayedCall(
        1500,
        () => {
          gameState.cam = this.cameras.main;
          config.audio.bgAudio.setVolume(0);
          this.scene.launch("EndScene");
          this.scene.pause("GameScene");
        },
        this
      );
    }
    if (gameState.correct < 6) {
      const scene2 = this.scene.get("HintScene");

      scene2.textHolderTween(1002, 500, 4500);

      this.rip1 = this.add.sprite(gameState.qnum * this.questionwidth + 725 + 491, 223, "rippleContactAnim").setOrigin(0.27);
      this.rip2 = this.add.sprite(gameState.qnum * this.questionwidth + 725 + 654, 323, "rippleContactAnim").setOrigin(0.27);
      this.rip3 = this.add.sprite(gameState.qnum * this.questionwidth + 725 + 444, 455, "rippleContactAnim").setOrigin(0.27);
      this.rip4 = this.add.sprite(gameState.qnum * this.questionwidth + 725 + 613, 556, "rippleContactAnim").setOrigin(0.27);

      this.lil1 = this.add
        .sprite(gameState.qnum * this.questionwidth + 725 + 491, 223, "lillyPadSinkAnim")
        .setOrigin(490 / 1280, 189 / 720)
        .setInteractive({ cursor: "pointer", pixelPerfect: true });
      this.lil2 = this.add
        .sprite(gameState.qnum * this.questionwidth + 725 + 654, 323, "lillyPadSinkAnim")
        .setOrigin(490 / 1280, 189 / 720)
        .setInteractive({ cursor: "pointer", pixelPerfect: true });
      this.lil3 = this.add
        .sprite(gameState.qnum * this.questionwidth + 725 + 444, 455, "lillyPadSinkAnim")
        .setOrigin(490 / 1280, 189 / 720)
        .setInteractive({ cursor: "pointer", pixelPerfect: true });
      this.lil4 = this.add
        .sprite(gameState.qnum * this.questionwidth + 725 + 613, 556, "lillyPadSinkAnim")
        .setOrigin(490 / 1280, 189 / 720)
        .setInteractive({ cursor: "pointer", pixelPerfect: true });

      this.bubble1 = this.add
        .image(gameState.qnum * this.questionwidth + 725 + 634, 287, "bubble")
        .setOrigin(0, 0.78)
        .setScale(0)
        .setDepth(1);
      this.bubble2 = this.add
        .image(gameState.qnum * this.questionwidth + 725 + 797, 387, "bubble")
        .setOrigin(0, 0.78)
        .setScale(0)
        .setDepth(1);
      this.bubble3 = this.add
        .image(gameState.qnum * this.questionwidth + 725 + 587, 519, "bubble")
        .setOrigin(0, 0.78)
        .setScale(0)
        .setDepth(1);
      this.bubble4 = this.add
        .image(gameState.qnum * this.questionwidth + 725 + 756, 619, "bubble")
        .setOrigin(0, 0.78)
        .setScale(0)
        .setDepth(1);

      this.opt1 = this.add
        .image(gameState.qnum * this.questionwidth + 725 + 634, 287, gameState.questionNumber + 1 + "_0")
        .setOrigin(0.5, 1)
        .setScale(0)
        .setDepth(1);
      this.opt2 = this.add
        .image(gameState.qnum * this.questionwidth + 725 + 797, 387, gameState.questionNumber + 1 + "_1")
        .setOrigin(0.5, 1)
        .setScale(0)
        .setDepth(1);
      this.opt3 = this.add
        .image(gameState.qnum * this.questionwidth + 725 + 587, 519, gameState.questionNumber + 1 + "_2")
        .setOrigin(0.5, 1)
        .setScale(0)
        .setDepth(1);
      this.opt4 = this.add
        .image(gameState.qnum * this.questionwidth + 725 + 756, 619, gameState.questionNumber + 1 + "_3")
        .setOrigin(0.5, 1)
        .setScale(0)
        .setDepth(1);
      this.opts = [this.opt1, this.opt2, this.opt3, this.opt4];
    } else {
      this.time.delayedCall(
        2500,
        () => {
          var path2 = new Phaser.Curves.Path(6725 + 917 + 500, 317).splineTo([6725 + 917 + 125, 200, 6725 + 917, 317]);
          this.shadow2 = this.add
            .image(6725 + 917 + 500, 317 + 110, "shadow")
            .setOrigin(0.5)
            .setTint(0x000)
            .setAlpha(0.5);

          this.greenfrogshadow = true;
          this.greenfrog = this.add.follower(path2, 6725 + 917, 552, "greenFrogJumpAnim").setOrigin((1066 + 80) / 1280, 336 / 720);

          this.greenfrog.startFollow({
            positionOnPath: true,
            duration: 650,
            yoyo: false,
            repeat: 0,
            rotateToPath: false,
            verticalAdjust: false,

            onStart: () => {
              this.greenfrog.play("greenfjumpfull");
              this.frogJumpAudio.play();
              this.tweens.add({
                targets: this.shadow2,
                scale: 0.8,
                duration: 320,
                yoyo: true,
                ease: "Linear",
              });
            },
          });

          this.time.delayedCall(
            3000,
            () => {
              var pathF = new Phaser.Curves.Path(gameState.qnum * this.questionwidth + 813 + 45, 317).splineTo([gameState.qnum * this.questionwidth + 813 + 45 + 300, 170, gameState.qnum * this.questionwidth + 813 + 45 + 600, 317]);
              redfrog.setPath(pathF);
            },
            [],
            this
          );

          this.time.delayedCall(
            5500,
            () => {
              gameState.cam = this.cameras.main;
              config.audio.bgAudio.setVolume(0);
              this.scene.launch("EndScene");
              this.scene.pause("GameScene");
            },
            this
          );
        },
        [],
        this
      );
    }
    this.time.delayedCall(
      3500,
      () => {
        this.bub1 = this.add
          .sprite(gameState.qnum * this.questionwidth + 725 + 634 + 62, 287 - 50, "bubbleBurstAnim")
          .setDepth(1)
          .setAlpha(0);
        this.bub2 = this.add
          .sprite(gameState.qnum * this.questionwidth + 725 + 797 + 62, 387 - 50, "bubbleBurstAnim")
          .setDepth(1)
          .setAlpha(0);
        this.bub3 = this.add
          .sprite(gameState.qnum * this.questionwidth + 725 + 587 + 62, 519 - 50, "bubbleBurstAnim")
          .setDepth(1)
          .setAlpha(0);
        this.bub4 = this.add
          .sprite(gameState.qnum * this.questionwidth + 725 + 756 + 62, 619 - 50, "bubbleBurstAnim")
          .setDepth(1)
          .setAlpha(0);

        if (padval == 1) {
          var pathL1 = new Phaser.Curves.Path(813 + 491 - 40 + (gameState.qnum - 1) * 1000, 180).splineTo([
            813 + 682 - 53 + (gameState.qnum - 1) * 1000,
            206 - 97,
            813 + 823 - 53 + (gameState.qnum - 1) * 1000,
            193 - 97,
            813 + 963 - 53 + (gameState.qnum - 1) * 1000,
            225 - 97,
            813 + 1084 - 53 + (gameState.qnum - 1) * 1000,
            306 - 97,
            gameState.qnum * this.questionwidth + 813 + 45,
            317,
          ]);
        } else if (padval == 2) {
          var pathL1 = new Phaser.Curves.Path(813 + 654 - 40 + (gameState.qnum - 1) * 1000, 280).splineTo([
            813 + 842 - 53 + (gameState.qnum - 1) * 1000,
            265 - 97,
            813 + 973 - 53 + (gameState.qnum - 1) * 1000,
            265 - 97,
            813 + 1094 - 53 + (gameState.qnum - 1) * 1000,
            335 - 97,
            gameState.qnum * this.questionwidth + 813 + 45,
            317,
          ]);
        } else if (padval == 3) {
          var pathL1 = new Phaser.Curves.Path(813 + 444 - 40 + (gameState.qnum - 1) * 1000, 412).splineTo([
            813 + 605 - 53 + (gameState.qnum - 1) * 1000,
            409 - 97,
            813 + 750 - 53 + (gameState.qnum - 1) * 1000,
            344.5 - 97,
            813 + 882 - 53 + (gameState.qnum - 1) * 1000,
            328.5 - 97,
            813 + 1039 - 53 + (gameState.qnum - 1) * 1000,
            357 - 97,
            gameState.qnum * this.questionwidth + 813 + 45,
            317,
          ]);
        } else if (padval == 4) {
          var pathL1 = new Phaser.Curves.Path(813 + 613 - 40 + (gameState.qnum - 1) * 1000, 513).splineTo([
            813 + 731 - 53 + (gameState.qnum - 1) * 1000,
            500 - 97,
            813 + 832 - 53 + (gameState.qnum - 1) * 1000,
            412 - 97,
            813 + 992 - 53 + (gameState.qnum - 1) * 1000,
            377.5 - 97,
            gameState.qnum * this.questionwidth + 813 + 45,
            317,
          ]);
        }
        redfrog.setPath(pathL1);

        if (!(gameState.correct == 6)) {
          this.displayq = true;
        } else {
          this.tweens.add({
            targets: this.shadow1,
            y: 317 + 110,
            duration: 650,
            ease: "Linear",
            onStart: () => {},
          });

          this.time.delayedCall(
            650,
            () => {
              this.Qrips[gameState.qnum].setOrigin(0.27).play("ripc");
              config.audio.ripcAudio.play();
            },
            this
          );
        }
      },
      [],
      this
    );
  }

  reattempt() {
    gameState.hneed = true;

    gameState.attempts++;
    //gameState.qnum*this.questionwidth+ 813+45,317

    this.repeatq = true;
    var pathR = new Phaser.Curves.Path(813 + 45 - 400 + gameState.qnum * 1000, 317).splineTo([813 + 45 - 200 + gameState.qnum * 1000, 200, 813 + 45 + gameState.qnum * 1000, 317]);
    this.shadow1.y = 317 + 110;
    redfrog.setAlpha(1);
    redfrog.setPath(pathR);

    this.bubble1.setTexture("bubble");
    this.bubble2.setTexture("bubble");
    this.bubble3.setTexture("bubble");
    this.bubble4.setTexture("bubble");

    this.opt1.setTexture(gameState.questionNumber + 1 + "_0");
    this.opt2.setTexture(gameState.questionNumber + 1 + "_1");
    this.opt3.setTexture(gameState.questionNumber + 1 + "_2");
    this.opt4.setTexture(gameState.questionNumber + 1 + "_3");

    this.enablepads(true);
  }

  replaceq() {
    gameState.attempts = 0;
    gameState.questionNumber++;
    this.shadow1.y = 317 + 110;

    const scene2 = this.scene.get("HintScene");

    scene2.objectFadeInOut(0, 1000, 0);

    if (gameState.questionNumber < 10) {
      this.tweens.add({
        targets: [this.bubble1, this.bubble2, this.bubble3, this.bubble4, this.opt1, this.opt2, this.opt3, this.opt4],
        alpha: 0,
        duration: 25,
        ease: "Linear",
        onStart: () => {
          this.bub1.setAlpha(1).play("burst");
          this.bub2.setAlpha(1).play("burst");
          this.bub3.setAlpha(1).play("burst");
          this.bub4.setAlpha(1).play("burst");
        },
        onComplete: () => {
          this.bubble1 = this.add
            .image(gameState.qnum * this.questionwidth + 725 + 634, 287, "bubble")
            .setOrigin(0, 0.78)
            .setScale(0)
            .setDepth(1);
          this.bubble2 = this.add
            .image(gameState.qnum * this.questionwidth + 725 + 797, 387, "bubble")
            .setOrigin(0, 0.78)
            .setScale(0)
            .setDepth(1);
          this.bubble3 = this.add
            .image(gameState.qnum * this.questionwidth + 725 + 587, 519, "bubble")
            .setOrigin(0, 0.78)
            .setScale(0)
            .setDepth(1);
          this.bubble4 = this.add
            .image(gameState.qnum * this.questionwidth + 725 + 756, 619, "bubble")
            .setOrigin(0, 0.78)
            .setScale(0)
            .setDepth(1);

          this.opt1 = this.add
            .image(gameState.qnum * this.questionwidth + 725 + 634, 287, gameState.questionNumber + 1 + "_0")
            .setOrigin(0.5, 1)
            .setScale(0)
            .setDepth(1);
          this.opt2 = this.add
            .image(gameState.qnum * this.questionwidth + 725 + 797, 387, gameState.questionNumber + 1 + "_1")
            .setOrigin(0.5, 1)
            .setScale(0)
            .setDepth(1);
          this.opt3 = this.add
            .image(gameState.qnum * this.questionwidth + 725 + 587, 519, gameState.questionNumber + 1 + "_2")
            .setOrigin(0.5, 1)
            .setScale(0)
            .setDepth(1);
          this.opt4 = this.add
            .image(gameState.qnum * this.questionwidth + 725 + 756, 619, gameState.questionNumber + 1 + "_3")
            .setOrigin(0.5, 1)
            .setScale(0)
            .setDepth(1);
          this.opts = [this.opt1, this.opt2, this.opt3, this.opt4];

          this.bub1 = this.add
            .sprite(gameState.qnum * this.questionwidth + 725 + 634 + 62, 287 - 50, "bubbleBurstAnim")
            .setDepth(1)
            .setAlpha(0);
          this.bub2 = this.add
            .sprite(gameState.qnum * this.questionwidth + 725 + 797 + 62, 387 - 50, "bubbleBurstAnim")
            .setDepth(1)
            .setAlpha(0);
          this.bub3 = this.add
            .sprite(gameState.qnum * this.questionwidth + 725 + 587 + 62, 519 - 50, "bubbleBurstAnim")
            .setDepth(1)
            .setAlpha(0);
          this.bub4 = this.add
            .sprite(gameState.qnum * this.questionwidth + 725 + 756 + 62, 619 - 50, "bubbleBurstAnim")
            .setDepth(1)
            .setAlpha(0);

          this.newq = true;

          const scene2 = this.scene.get("HintScene");

          scene2.textHolderTween(1002, 500, 1000);

          this.time.delayedCall(
            600,
            () => {
              var pathR = new Phaser.Curves.Path(813 + 45 - 400 + gameState.qnum * 1000, 317).splineTo([813 + 45 - 200 + gameState.qnum * 1000, 200, 813 + 45 + gameState.qnum * 1000, 317]);
              redfrog.setAlpha(1);
              redfrog.setPath(pathR);
              this.enablepads(true);
            },
            this
          );
        },
      });
    } else {
      this.time.delayedCall(
        1500,
        () => {
          gameState.cam = this.cameras.main;
          config.audio.bgAudio.setVolume(0);
          this.scene.launch("EndScene");
          this.scene.pause("GameScene");
        },
        this
      );
    }
  }

  update() {
    this.shadow1.x = redfrog.x + 20;
    if (this.greenfrogshadow) {
      this.shadow2.x = this.greenfrog.x;
    }

    if (this.rip) {
      this.rip = false;

      var value = Phaser.Math.Between(1, 5);

      this.ripples[value].setTexture("randomRippleAnim").setOrigin(0.28).play("rrip"); //.setScale(()=>{if(value>2){return 1} else{return 1}})

      var value1 = Phaser.Math.Between(11, 30);

      this.time.delayedCall(
        value1 * 100,
        () => {
          if (this.clickActive) {
            this.rip = true;
          }
        },
        [],
        this
      );
    }
  }
}
